var render = function render(){
  var _vm$advertiserRevshar, _vm$advertiserRevshar2, _vm$advertiserRevshar3, _vm$advertiserRevshar4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "w-full bg-gray-200 p-1 border-b mb-2"
  }, [_c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-5 gap-1"
  }, [_c('YInput', {
    attrs: {
      "label": "Advertiser"
    },
    model: {
      value: _vm.filters.advertiserName.value,
      callback: function ($$v) {
        _vm.$set(_vm.filters.advertiserName, "value", $$v);
      },
      expression: "filters.advertiserName.value"
    }
  }), _c('Superselect', {
    attrs: {
      "title": "Last Run Status",
      "placeholder": "Last Run Status",
      "multiple": false,
      "options": _vm.filterOptions.lastRunStatus
    },
    model: {
      value: _vm.filters.lastRunStatus.value,
      callback: function ($$v) {
        _vm.$set(_vm.filters.lastRunStatus, "value", $$v);
      },
      expression: "filters.lastRunStatus.value"
    }
  }), _c('Superselect', {
    attrs: {
      "title": "Helpers",
      "placeholder": "Helpers",
      "multiple": false,
      "options": _vm.filterOptions.helpers
    },
    model: {
      value: _vm.filters.helpers.value,
      callback: function ($$v) {
        _vm.$set(_vm.filters.helpers, "value", $$v);
      },
      expression: "filters.helpers.value"
    }
  })], 1)]), (_vm$advertiserRevshar = _vm.advertiserRevshare) !== null && _vm$advertiserRevshar !== void 0 && _vm$advertiserRevshar.data ? _c('YTable', {
    attrs: {
      "data": (_vm$advertiserRevshar2 = _vm.advertiserRevshare) === null || _vm$advertiserRevshar2 === void 0 ? void 0 : _vm$advertiserRevshar2.data,
      "loading": _vm.$apollo.queries.advertiserRevshare.loading
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function (props) {
        return [_c('td', [_c('router-link', {
          staticClass: "link block",
          attrs: {
            "to": {
              name: 'Advertiser',
              params: {
                id: props.rowData.advertiserAccount.advertiser.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(props.rowData.advertiserAccount.advertiser.id) + " - " + _vm._s(props.rowData.advertiserAccount.advertiser.name) + " ")])], 1), _c('td', [_vm._v(_vm._s(props.rowData.advertiserAccountId))]), _c('td', [_vm._v(_vm._s(props.rowData.helperClass))]), _c('td', {
          staticClass: "text-center"
        }, [_c('Tag', {
          attrs: {
            "color": props.rowData.status === 'Ok' ? 'blue' : props.rowData.status === 'active' ? 'darkGreen' : props.rowData.status === 'dead' ? 'darkRed' : 'gray'
          }
        }, [_vm._v(" " + _vm._s(props.rowData.status) + " ")])], 1), _c('td', {
          staticClass: "text-center"
        }, [props.rowData.lastStatus ? _c('Tag', {
          attrs: {
            "color": _vm.lastStatusColors[props.rowData.lastStatus ? props.rowData.lastStatus.toLowerCase() : ''] || 'gray'
          }
        }, [_vm._v(" " + _vm._s(props.rowData.lastStatus) + " ")]) : _vm._e()], 1), _c('td', [_vm._v(" " + _vm._s(props.rowData.lastStatus && props.rowData.lastStatus.toLowerCase() !== 'ok' ? props.rowData.lastMessage : '') + " ")]), _c('td', [_vm._v(_vm._s(props.rowData.lastPulled))]), _c('td', [_vm._v(_vm._s(props.rowData.url))])];
      }
    }], null, false, 1239675169)
  }, [_c('template', {
    slot: "header-row"
  }, [_c('th', [_vm._v("Advertiser")]), _c('th', [_vm._v("Account ID")]), _c('th', [_vm._v("Helper Class")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Last Run Status")]), _c('th', [_vm._v("Last Run Message")]), _c('th', [_vm._v("Last Pulled")]), _c('th', [_vm._v("URL")])])], 2) : _vm._e(), (_vm$advertiserRevshar3 = _vm.advertiserRevshare) !== null && _vm$advertiserRevshar3 !== void 0 && _vm$advertiserRevshar3.paginatorInfo ? _c('YPagination', {
    key: _vm.totalPages,
    attrs: {
      "data": (_vm$advertiserRevshar4 = _vm.advertiserRevshare) === null || _vm$advertiserRevshar4 === void 0 ? void 0 : _vm$advertiserRevshar4.paginatorInfo
    },
    on: {
      "load-page": _vm.loadPage,
      "next-page": _vm.nextPage,
      "previous-page": _vm.previousPage,
      "per-page": _vm.perPageSelection
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }